/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { UserInfo } from './userInfo';

export interface AnagraficaView { 
    indirizzoResidenza?: string;
    provinciaResidenza?: string;
    comuneNascita?: string;
    comuneResidenza?: string;
    updatedAt?: Date;
    createdAt?: Date;
    codicePratica?: string;
    cittadinanza?: string;
    provinciaNascita?: string;
    isee?: number;
    possessoIsee?: boolean;
    isResidente?: boolean;
    cellulare?: string;
    dataNascita?: string;
    user?: UserInfo;
    annoDiRiferimento?: string;
    nome?: string;
    cognome?: string;
    codiceFiscale?: string;
    id?: string;
}